export default __webpack_public_path__ + "static/media/about_my_home_hero.cef243a3.webp";